import TemplateImpressao from './TemplateImpressao';

export default TemplateImpressao;